import { useState } from "react";
import { Container, Table, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import "./gcc.css";

const companies = [
  {
    name: "Apex Fintech IFSC Ltd",
    sector: "FinTech",
    location: "SEZ Zone, GIFT City",
    employees: "150+",
    status: "Active",
  },
  {
    name: "Quant Analytics Labs",
    sector: "AI & Analytics",
    location: "GIFT One Tower",
    employees: "200+",
    status: "Active",
  },
  {
    name: "Starlight Tech Labs IFSC",
    sector: "Technology & Software",
    location: "IFSCA Tower",
    employees: "50+",
    status: "Active",
  },
  {
    name: "Global Insure Corp",
    sector: "BFSI",
    location: "GIFT Two Tower",
    employees: "300+",
    status: "In Onboarding",
  },
  {
    name: "ScaleTech Engineering",
    sector: "Technology & Software",
    location: "Signature Tower",
    employees: "120+",
    status: "In Onboarding",
  },
  {
    name: "Deccan Asset Advisors",
    sector: "Asset & Legal",
    location: "SEZ Zone, GIFT City",
    employees: "80+",
    status: "Approved",
  },
];

const filters = [
  "All Sectors",
  "FinTech",
  "BFSI",
  "Technology & Software",
  "AI & Analytics",
  "Asset & Legal",
];

const Gcc = () => {
  const [sector, setSector] = useState("All Sectors");
  const [search, setSearch] = useState("");

  const filtered = companies.filter((item) => {
    const sectorMatch = sector === "All Sectors" || item.sector === sector;

    const searchMatch =
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.location.toLowerCase().includes(search.toLowerCase());

    return sectorMatch && searchMatch;
  });
  return (
    <div>
      <section className="directory-section">
        <Container>
          <div className="directory-card">
            <div className="search-box">
              <FaSearch />
              <Form.Control
                placeholder="Search GCC companies..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="filter-bar">
              <span>Filter by Sector :</span>

              {filters.map((item) => (
                <button
                  key={item}
                  onClick={() => setSector(item)}
                  className={sector === item ? "active" : ""}
                >
                  {item}
                </button>
              ))}
            </div>

            <Table responsive hover>
              <thead>
                <tr>
                  <th>ENTITY NAME</th>
                  <th>SECTOR</th>
                  <th>LOCATION</th>
                  <th>EMPLOYEES</th>
                  <th>STATUS</th>
                </tr>
              </thead>

              <tbody>
                {filtered.map((item, i) => (
                  <tr key={i}>
                    <td>{item.name}</td>
                    <td>{item.sector}</td>
                    <td>{item.location}</td>
                    <td>{item.employees}</td>
                    <td>
                      <span
                        className={`status ${item.status.replace(/\s/g, "")}`}
                      >
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Gcc;
